import { z } from 'zod'
import { UserId } from './ids.ts'

// The personal/family split shared by every mini-app that has one. Personal
// items have ownerId = the user who created them; only that user sees or
// mutates them. Family items have ownerId = null; any household member can.
export const Mode = z.enum(['personal', 'family'])
export type Mode = z.infer<typeof Mode>

export const OwnerId = UserId.nullable()
export type OwnerId = z.infer<typeof OwnerId>
